import { render } from "./HowToAccount.vue?vue&type=template&id=f8471e7a"
import script from "./HowToAccount.vue?vue&type=script&lang=js"
export * from "./HowToAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__